import { render, staticRenderFns } from "./StockReductionList_List.vue?vue&type=template&id=ff87a5a8&"
import script from "./StockReductionList_List.vue?vue&type=script&lang=js&"
export * from "./StockReductionList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports